import React from "react";
import "./GetMusicOnFizy.css";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Helmet } from "react-helmet";

const GetMusicOnFizy = () => {

  const steps = [
    "Create your FT Tunes account",
    "Upload your music catalog",
    "Select Fizy distribution",
    "Music delivered to Fizy platform",
    "Reach millions of listeners",
    "Earn streaming royalties"
  ];

  return (
    <>
      <Helmet>
        <title>
          Get Your Music on Fizy | Fizy Music Distribution | FT Tunes
        </title>

        <meta
          name="description"
          content="Distribute your music on Fizy through FT Tunes. Reach millions of listeners across Turkey with one of the leading music streaming platforms."
        />

        <meta
          name="keywords"
          content="Fizy distribution, upload music to Fizy, Fizy music platform, distribute music Turkey, FT Tunes distribution"
        />

        <meta name="robots" content="index, follow" />
      </Helmet>

      <div className="fizy-page">

        {/* HERO */}
        <section className="fizy-hero">
          <Container>

            <img
              src="/Images/fizy-logo.png"
              alt="Fizy Music Platform"
              className="fizy-logo"
            />

            <h1>Get Your Music on Fizy</h1>

            <p>
              Distribute your music to Fizy and reach millions of music
              fans across Turkey. Expand your global audience and grow
              your streaming revenue with FT Tunes.
            </p>

            <Button
              className="gradient-btn-fizy"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Start Releasing Music
            </Button>

          </Container>

          <div className="hero-glow-fizy"></div>
        </section>


        {/* SHOWCASE */}
        <section className="fizy-showcase">
          <Container>
            <Row className="align-items-center">

              <Col md={6}>
                <h2>Reach Turkish Music Listeners</h2>

                <p>
                  Fizy is one of Turkey’s leading music streaming platforms,
                  giving artists powerful exposure across mobile, web,
                  and telecom-based streaming services.
                </p>

                <Button
                  className="outline-btn-fizy"
                  href="https://dashboard.fttunes.com/register.php"
                  target="_blank"
                >
                  Upload Music
                </Button>
              </Col>

              <Col md={6}>
                <img
                  src="/Images/get-your-music-on-fizy.png"
                  alt="Get Your Music On Fizy"
                  className="fizy-image"
                />
              </Col>

            </Row>
          </Container>
        </section>


        {/* STEPS */}
        <section className="fizy-steps">
          <Container>

            <h2 className="section-title">How It Works</h2>

            <Row>
              {steps.map((step, index) => (
                <Col md={4} key={index}>
                  <div className="step-card-fizy">
                    <span>0{index + 1}</span>
                    <p>{step}</p>
                  </div>
                </Col>
              ))}
            </Row>

          </Container>
        </section>


        {/* BENEFITS */}
        <section className="fizy-benefits">
          <Container>

            <h2 className="section-title">
              Why Distribute Music to Fizy
            </h2>

            <Row>

              <Col md={3}>
                <div className="benefit-card-fizy">
                  <h5>Millions of Users</h5>
                  <p>Reach large audiences across Turkey.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-fizy">
                  <h5>Mobile Streaming</h5>
                  <p>Available across telecom networks.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-fizy">
                  <h5>Global Exposure</h5>
                  <p>Expand your international fanbase.</p>
                </div>
              </Col>

              <Col md={3}>
                <div className="benefit-card-fizy">
                  <h5>Royalty Earnings</h5>
                  <p>Earn revenue from every stream.</p>
                </div>
              </Col>

            </Row>

          </Container>
        </section>


        {/* CTA */}
        <section className="fizy-cta">
          <Container>

            <h2>Start Reaching Fizy Listeners Today</h2>

            <Button
              className="gradient-btn-fizy big"
              href="https://dashboard.fttunes.com/register.php"
              target="_blank"
            >
              Distribute Now
            </Button>

          </Container>
        </section>

      </div>
    </>
  );
};

export default GetMusicOnFizy;